import { Link } from 'react-router-dom'
import { utmUtils, useStoredUtmsVersion } from '@/hooks/useUtmTracking'

const UtmLink = ({ to, children, onClick, ...props }) => {
  // Re-render as soon as UTMs are captured,
  // instead of computing 'to' once and going stale until another navigation.
  useStoredUtmsVersion()

  const handleClick = e => {
    // Call the original onClick if provided
    if (onClick) {
      onClick(e)
    }
  }

  // Append UTM parameters to the 'to' prop (no-op during SSR)
  const urlWithUtms = utmUtils.createUrlWithUtms(to)

  // For internal links, extract just the pathname and search params
  let finalTo = to
  try {
    const url = new URL(
      urlWithUtms,
      typeof window === 'undefined'
        ? 'https://yourclaimmatters.co.uk'
        : window.location.origin
    )
    finalTo = url.pathname + url.search
  } catch {
    // Fall back to the original 'to' if URL parsing fails
  }

  return (
    <Link to={finalTo} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}

export default UtmLink
